import React from "react";
import FinalForm from "./FinalForm";

function MultiStepForm() {
	return (
		<div className="step-form">
			<FinalForm />
		</div>
	);
}

export default MultiStepForm;
